<template>
  <v-dialog v-if="open" v-model="open" max-width="600px">
    <v-card v-if="tgtCm">
      <v-card-title>
        <span>{{ title }}</span>
        <v-spacer></v-spacer>
        <v-icon class="c-close" @click="closeDialog">close</v-icon>
      </v-card-title>
      <v-container grid-list-lg text-xs-left>
        <v-layout column wrap>
          <v-flex v-if="dialogMsg" class="c-msg">{{ dialogMsg }}</v-flex>
          <v-flex>
            <div class="c-flex c c-member">
              <template v-if="isTgtSelf">
                <div class="c-self-mark">
                  <v-icon size="45" color="amber">mdi-bookmark</v-icon>
                </div>
              </template>

              <div v-if="!isGuest && isTgtSelf" class="c-img">
                <select-cover
                  :cid="tgtCm.community_id"
                  type="profile"
                  ref="cover"
                  :addTitle="false"
                  btnType="camera"
                  :coverPath="cidToCmCover(tgtCm.community_id)"
                />
              </div>
              <div v-else class="c-img c-cover-160">
                <c-img :src="`/cover/cm/${tgtCm.id}/${tgtCm.cover_changed_at}/`" />
              </div>

              <div class="c-explain">
                <div class="c-com c-flex c">
                  <community-chip-s :cid="tgtC.id" :wCss="leTbS ? 'ls' : 'lm'" />
                  <v-spacer key="d"></v-spacer>
                  <v-tooltip v-if="ope.unfriend" top>
                    <v-icon slot="activator" size="23" color="clr-danger" @click="onUnfriendClicked"
                      >mdi-account-off</v-icon
                    >
                    <span>{{ $T('page.member.info.unfriend') }}</span>
                  </v-tooltip>
                </div>
                <div class="c-name">
                  <v-text-field
                    v-if="!isGuest && isTgtSelf"
                    data-vv-name="profile"
                    data-vv-validate-on="blur"
                    ref="input_profile"
                    :label="$T('attributes.profile')"
                    v-model="profileName"
                    color="clr-primary"
                    counter="50"
                    v-validate="'required|max:50'"
                    :error-messages="getMessage('profile')"
                    required
                    autofocus
                  ></v-text-field>
                  <template v-else>{{ getCmName(tgtCm) }}</template>
                </div>
                <!-- issue#30: タグの表示・設定（名前の下） -->
                <div v-if="canTag" class="c-tag-edit">
                  <!-- 入力中 -->
                  <div v-if="tagEditing" class="c-tag-input">
                    <v-text-field
                      v-model="tagInput"
                      ref="memberTagField"
                      :placeholder="$T('page.member.tag.input.msg')"
                      maxlength="20"
                      counter="20"
                      color="clr-primary"
                      single-line
                      hide-details
                      class="c-tag-field"
                      @keyup.enter="onRetagClicked"
                    ></v-text-field>
                    <v-btn
                      color="clr-btn"
                      flat
                      small
                      :loading="tagLoading"
                      :disabled="tagLoading"
                      @click.native="onRetagClicked"
                      >{{ $T('button.save') }}</v-btn
                    >
                  </div>
                  <!-- 折りたたみ: タグ表示は一覧と同じ表現(c-tag-mini)に統一。クリックで入力 -->
                  <div v-else class="c-tag-row">
                    <span v-if="tgtCm.tag" class="c-tag-mini c-hand" @click="startEditMemberTag">
                      <v-icon size="11">mdi-tag</v-icon>{{ tgtCm.tag }}
                    </span>
                    <v-chip
                      v-else
                      small
                      outline
                      color="grey"
                      class="c-tag-add-chip c-hand"
                      @click.native="startEditMemberTag"
                    >
                      <v-icon left small>mdi-tag-outline</v-icon>{{ $T('page.member.tag.add') }}
                    </v-chip>
                  </div>
                  <div v-if="tgtCm.init_tag" class="c-tag-origin">
                    {{ $T('page.member.tag.origin') }} {{ tgtCm.init_tag }}
                  </div>
                  <div v-if="tagErr" class="c-tag-err">{{ tagErr }}</div>
                </div>
                <template v-if="tgtCm.is_friend">
                  <div
                    v-if="!$utils.isFriendStatusActive(tgtCm.friend_status)"
                    class="c-role f-danger"
                  >
                    {{ $utils.friendStatus(tgtCm.friend_status) }}
                  </div>
                </template>
                <template v-else>
                  <div v-if="ope.change_role">
                    <v-select
                      data-vv-name="cmRole"
                      :items="roles"
                      item-text="text"
                      item-value="value"
                      ref="input_role"
                      :label="$T('attributes.role')"
                      v-model="data.role"
                      color="clr-primary"
                      v-validate="'required'"
                      required
                      :disabled="!!loading"
                    ></v-select>
                  </div>
                  <div v-else-if="tgtCm.status == 1" class="c-role">
                    {{ $utils.role(tgtCm.role) }}
                  </div>
                  <div v-else class="c-role f-danger">
                    {{ $utils.status(tgtCm.status, tgtCm.role) }}
                  </div>
                </template>
                <!-- Issue #12: メンバーへのメール/トーク/アルバム/イベント等の会員専用操作はゲストに描画しない -->
                <div class="c-icons" v-if="!isGuest">
                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      flat
                      icon
                      color="clr-btn"
                      :disabled="
                        isGuest ||
                        !!tgtCm.guest ||
                        isTgtSelf ||
                        tgtCm.status != 1 ||
                        (isFriend && !isActiveFriend)
                      "
                      @click.prevent="onMailClicked"
                    >
                      <c-svg t="mail" class="mail"></c-svg>
                    </v-btn>
                    <span>{{ $T('mail.to') }}</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      flat
                      icon
                      color="clr-btn"
                      :loading="chatLoading"
                      :disabled="
                        isGuest ||
                        !!tgtCm.guest ||
                        isTgtSelf ||
                        tgtCm.status != 1 ||
                        (isFriend && !isActiveFriend)
                      "
                      @click.prevent="onTalkClicked"
                    >
                      <c-svg t="talk" class="talk"></c-svg>
                    </v-btn>
                    <span>{{ $T('talk.to') }}</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      flat
                      icon
                      color="clr-btn"
                      :disabled="
                        isGuest ||
                        (tgtCm.guest && !isUserAdmin) ||
                        tgtCm.status != 1 ||
                        (isFriend && !isActiveFriend)
                      "
                      @click.prevent="onAlbumClicked"
                    >
                      <c-svg t="photo" class="photo"></c-svg>
                    </v-btn>
                    <span>{{ $T('page.album.share.picture') }}</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      flat
                      icon
                      color="clr-btn"
                      :disabled="
                        isGuest ||
                        (tgtCm.guest && !isUserAdmin) ||
                        tgtCm.status != 1 ||
                        (isFriend && !isActiveFriend)
                      "
                      @click.prevent="openEditEvent = true"
                    >
                      <c-svg t="c-calendar" class="c-calendar"></c-svg>
                    </v-btn>
                    <span>{{ $T('page.cal.schedule') }}</span>
                  </v-tooltip>
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex v-if="errMsg" class="c-errmsg">
            {{ errMsg }}
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="ope.ok"
          color="clr-btn"
          flat
          @click.native="onOkClicked"
          :loading="loading == 'SELF'"
          :disabled="!!loading"
          >{{ $T('button.ok') }}</v-btn
        >
        <v-btn
          v-if="ope.approve && !isGuest"
          color="clr-btn"
          outline
          @click.native="onApproveClicked"
          :disabled="!!loading"
          :loading="loading == 'APPROVE'"
          >{{ $T('button.approval') }}</v-btn
        >
        <v-btn
          v-if="ope.deny && !isGuest"
          color="clr-danger"
          outline
          @click.native="onRejectClicked"
          :disabled="!!loading"
          :loading="loading == 'DENY'"
          >{{ $T('button.rejection') }}</v-btn
        >
        <v-btn
          v-if="ope.change_role && data.role != -1"
          color="clr-btn"
          flat
          depressed
          @click.native="onChangeRoleClicked"
          :disabled="data.role == tgtCm.role || !!loading"
          :loading="loading == 'CHANGE_ROLE'"
          >{{ $T('button.save') }}</v-btn
        >
        <v-btn
          v-if="ope.unsubscribe && data.role == -1"
          color="clr-danger"
          flat
          depressed
          @click.native="onUnsubscribeClicked"
          :disabled="!!loading"
          :loading="loading == 'UNSUBSCRIBE'"
          >{{ $T('page.member.info.unsubscribe') }}</v-btn
        >
        <v-btn
          v-if="ope.ban"
          color="clr-danger"
          flat
          @click.native="onBanClicked"
          :disabled="!!loading"
          :loading="loading == 'BAN'"
          >{{ $T('button.ban') }}</v-btn
        >
        <v-btn
          v-if="ope.ban_reset"
          color="clr-danger"
          flat
          @click.native="onBanResetClicked"
          :disabled="!!loading"
          :loading="loading == 'BAN_RESET'"
          >{{ $T('button.ban_reset') }}</v-btn
        >
        <v-btn
          v-if="ope.cancel"
          color="clr-btn-cancel"
          flat
          @click.native="onCancelClicked"
          :disabled="!!loading"
          >{{ $T('button.cancel') }}</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>

    <edit-post-menu-list-dialog
      v-model="postDialog"
      :initCid="tgtCm ? tgtCm.community_id : 0"
      :initMembers="tgtCm ? [`m${tgtCm.id}`] : null"
    />

    <edit-event-dialog
      v-if="openEditEvent"
      :initCid="tgtC.id"
      :members="toMembers"
      :targetMoment="getCurrent()"
      @registered="onEventRegistered"
      @close="openEditEvent = false"
    ></edit-event-dialog>

    <confirm-dialog
      v-if="unfriendConfirmDialog"
      :open="unfriendConfirmDialog"
      :dialogTitle="$T('page.member.info.unfriend')"
      :dialogText="$T('page.member.info.unfriend_msg')"
      @cancel="onUnfriendCanceled"
      @ok="onUnfriendConfirmed"
    />
  </v-dialog>
</template>

<script>
import { createPersonalTalk } from '../../api/communityTalk'
import UTILS from '../../utils/utils'
import { CONST } from '../../constant'
import {
  approve,
  reject,
  changeRole,
  unsubscribe,
  ban,
  resetBan,
  saveNameAndCover,
  retagCommunityMember,
  retagFriend,
} from '../../api/communityMember'
import talkPlugin from '../../utils/plugin/talkPlugin'
import editEventDialog from '../event/EditEventDialog'
import selectCover from '../common/SelectCover'
import editPostMenuListDialog from '../post/EditPostMenuListDialog'
import confirmDialog from '../common/ConfirmDialog'

export default {
  components: {
    'edit-event-dialog': editEventDialog,
    'select-cover': selectCover,
    'edit-post-menu-list-dialog': editPostMenuListDialog,
    'confirm-dialog': confirmDialog,
  },
  mixins: [talkPlugin],
  data() {
    return {
      open: false,
      openEditEvent: false,
      postDialog: false,
      title: $T('page.member.info.title'),
      dialogMsg: null,
      errMsg: null,
      tgtCm: null,
      profileCover: null,
      profileName: null,
      ope: {},
      loading: false,
      chatLoading: false,
      data: {
        role: 0,
      },
      selectCoverDialog: false,
      unfriendConfirmDialog: false,
      // issue#30: 招待タグの編集
      tagInput: '',
      tagLoading: false,
      tagErr: null,
      tagEditing: false,
    }
  },
  watch: {},
  computed: {
    roles() {
      if (this.userRole == 1) {
        return [
          { value: 1, text: this.$utils.role(1) },
          { value: 2, text: this.$utils.role(2) },
          { value: 3, text: this.$utils.role(3) },
          { value: -1, text: $T('page.member.info.unsubscribe') },
        ]
      } else {
        return [
          { value: 2, text: this.$utils.role(2) },
          { value: 3, text: this.$utils.role(3) },
          { value: -1, text: $T('page.member.info.unsubscribe') },
        ]
      }
    },
    tgtC() {
      return this.cMap[this.tgtCm.community_id]
    },
    userCmid() {
      return this.tgtC.cmid
    },
    userRole() {
      return this.tgtC.role
    },
    isFriend() {
      return this.tgtCm && !!this.tgtCm.is_friend
    },
    isActiveFriend() {
      return this.isFriend && this.tgtCm.friend_status == CONST.FRIEND_STATUS.ACTIVE
    },
    isTgtSelf() {
      return this.userCmid == this.tgtCm.id
    },
    isUserAdmin() {
      return this.userRole == 1 || this.userRole == 2
    },
    toMembers() {
      return [`m${this.tgtCm.id}`]
    },
    // issue#30: 招待タグを編集できるか
    // フレンド = 招待者本人（BE が member_id を返した行のみ）/ 通常メンバー = owner/manager
    canTag() {
      if (this.isGuest || !this.tgtCm || this.isTgtSelf) return false
      if (this.isFriend) return !!this.tgtCm.member_id
      return this.isUserAdmin && this.tgtCm.status == 1 && this.tgtCm.role != 4
    },
  },
  methods: {
    openDialog(cm) {
      this.loading = false
      this.dialogMsg = null
      this.postDialog = false
      this.errMsg = null
      this.ope = {}
      this.tgtCm = cm
      this.profileCover = cm.cm_cover_path
      this.profileName = cm.nickname
      this.data.role = cm.role
      // issue#30: タグ編集状態の初期化
      this.tagInput = cm.tag || ''
      this.tagErr = null
      this.tagLoading = false
      this.tagEditing = false

      if (this.tgtCm.status == 1) {
        // active target
        if (this.isTgtSelf) {
          // self
          this.ope.ok = true
          if (!this.isGuest) this.ope.cancel = true
        } else if (cm.role == 4) {
          // target is guest
          this.ope.ok = true
        } else if (cm.is_friend) {
          if (cm.friend_status == CONST.FRIEND_STATUS.ACTIVE) {
            this.ope.cancel = true
            this.ope.unfriend = true
          } else if (cm.friend_status == CONST.FRIEND_STATUS.beRequested) {
            this.dialogMsg = $T('page.member.info.approval.friend.msg')
            this.canChangeRole = true
            this.ope.cancel = false
            this.ope.approve = true
            this.ope.deny = true
          } else if (
            cm.friend_status == CONST.FRIEND_STATUS.CANCEL ||
            cm.friend_status == CONST.FRIEND_STATUS.REFUSE
          ) {
            this.dialogMsg = $T('page.member.info.ban.friend.msg')
            this.ope.cancel = true
            this.ope.ban = true
          } else if (cm.friend_status == CONST.FRIEND_STATUS.BAN) {
            this.ope.cancel = true
            this.ope.ban_reset = true
          } else {
            this.ope.ok = true
          }
          // target is guest
        } else if (this.userRole == 1) {
          // user is super user
          this.ope.cancel = true
          this.ope.change_role = true
          this.ope.unsubscribe = true
        } else if (this.userRole == 2) {
          // user is admin
          if (this.tgtCm.role == 1) {
            this.ope.ok = true
          } else {
            this.ope.cancel = true
            this.ope.change_role = true
            this.ope.unsubscribe = true
          }
        } else {
          // user is member
          this.ope.ok = true
        }
      } else if (this.tgtCm.status == 2) {
        // waiting confirmation
        if (this.isUserAdmin) {
          this.dialogMsg = $T('page.member.info.approval.msg')
          this.canChangeRole = true
          this.ope.cancel = false
          this.ope.approve = true
          this.ope.deny = true
        } else {
          this.ope.ok = true
        }
      } else if (this.tgtCm.status == 9 || this.tgtCm.status == 10) {
        // denied or retired
        if (this.isUserAdmin) {
          this.dialogMsg = $T('page.member.info.ban.msg')
          this.ope.cancel = true
          this.ope.ban = true
        } else {
          this.ope.ok = true
        }
      } else if (this.tgtCm.status == 99) {
        // banned or other
        if (this.isUserAdmin) {
          this.ope.cancel = true
          this.ope.ban_reset = true
        } else {
          this.ope.ok = true
        }
      } else {
        console.error('UNKNOWN STATUS[' + this.tgtCm.status + ']')
        this.ope.ok = true
      }

      this.open = true
    },
    closeDialog() {
      this.open = false
    },
    onCancelClicked() {
      this.closeDialog()
    },
    onOkClicked() {
      if (this.isTgtSelf && !this.isGuest) {
        return this.saveSelf()
      }
      this.closeDialog()
    },
    onApproveClicked() {
      this.callApi(approve, 3, 1, CONST.FRIEND_STATUS.ACTIVE)
    },
    onRejectClicked() {
      this.callApi(reject, 3, 9, CONST.FRIEND_STATUS.REFUSE)
    },
    onUnfriendClicked() {
      this.unfriendConfirmDialog = true
    },
    onUnfriendConfirmed() {
      this.callApi(unsubscribe, this.tgtCm.role, 1, CONST.FRIEND_STATUS.CANCEL)
      this.unfriendConfirmDialog = false
    },
    onUnfriendCanceled() {
      this.unfriendConfirmDialog = false
    },
    onChangeRoleClicked() {
      var data = new FormData()
      data.append('role', this.data.role)

      this.loading = 'CHANGE_ROLE'
      var self = this
      changeRole(this.tgtCm.id, data)
        .then(function (response) {
          self.loading = false
          self.$emit('changeValues', self.tgtCm.id, self.data.role, 1)
          self.closeDialog()
        })
        .catch(function (error) {
          self.loading = false
          self.setError(error)
        })
    },
    onUnsubscribeClicked() {
      this.callApi(unsubscribe, this.tgtCm.role, 10, CONST.FRIEND_STATUS.CANCEL)
    },
    onBanClicked() {
      this.callApi(ban, this.tgtCm.role, 99, CONST.FRIEND_STATUS.BAN)
    },
    onBanResetClicked() {
      this.callApi(resetBan, this.tgtCm.role, 10, CONST.FRIEND_STATUS.CANCEL)
    },
    callApi(func, toRole, toStatus, toFriendStatus, data) {
      if (func == approve) {
        this.loading = 'APPROVE'
      } else if (func == reject) {
        this.loading = 'DENY'
      } else if (func == unsubscribe) {
        this.loading = 'UNSUBSCRIBE'
      } else if (func == ban) {
        this.loading = 'BAN'
      } else if (func == resetBan) {
        this.loading = 'BAN_RESET'
      } else {
        this.loading = true
      }
      var cmid = this.tgtCm.id
      var self = this
      func(cmid, data)
        .then(function (response) {
          self.loading = false
          self.$emit('changeValues', cmid, toRole, self.tgtCm.is_friend ? toFriendStatus : toStatus)
          self.closeDialog()
        })
        .catch(function (error) {
          self.loading = false
          self.setError(error)
        })
    },
    setError(error) {
      if (error && error.errors && error.errors.cmid) {
        this.errMsg = error.errors.cmid[0]
      } else {
        this.errMsg = $T('error.unknown')
        console.error(error)
      }
    },
    // issue#30: タグ入力欄を開く（付与chip／タグchipのクリックから。既存タグはプリフィル）
    startEditMemberTag() {
      this.tagInput = (this.tgtCm && this.tgtCm.tag) || ''
      this.tagErr = null
      this.tagEditing = true
      var self = this
      this.$nextTick(function () {
        if (self.$refs.memberTagField && self.$refs.memberTagField.focus) {
          self.$refs.memberTagField.focus()
        }
      })
    },
    // issue#30: 招待タグの付け替え（フレンド→friend/retag, メンバー→member/retag）
    onRetagClicked() {
      var t = (this.tagInput || '').trim()
      this.tagErr = null
      // 空入力: 既存タグがあれば「クリア」(空をBEへ送る)、無ければ追加対象なしでエラー
      if (!t && !(this.tgtCm && this.tgtCm.tag)) {
        this.tagErr = $T('page.member.tag.empty')
        return
      }
      if (t.length > 20) {
        this.tagErr = $T('page.member.invite.tag.too_long')
        return
      }
      var self = this
      var cmid = this.tgtCm.id
      this.tagLoading = true
      var data = new FormData()
      var apiCall
      if (this.isFriend) {
        data.append('friend_mid', this.tgtCm.member_id)
        data.append('tag', t)
        apiCall = retagFriend(data)
      } else {
        data.append('cid', this.tgtCm.community_id)
        data.append('cmid', cmid)
        data.append('tag', t)
        apiCall = retagCommunityMember(data)
      }
      apiCall
        .then(function () {
          self.tagLoading = false
          self.$set(self.tgtCm, 'tag', t)
          self.$emit('tagChanged', { cmid: cmid, tag: t })
          // 入力欄を畳んでチップ表示に戻す（再編集はチップクリック）
          self.tagEditing = false
        })
        .catch(function (error) {
          self.tagLoading = false
          self.tagErr = $T('common.failed.edit')
          console.error('failed to retag', error)
        })
    },
    onMailClicked() {
      this.postDialog = true
    },
    onTalkClicked() {
      var result = this.gotoPersonalTalk(this.userCmid, this.tgtCm.id)
      if (result) return
      var d = {
        cid: this.tgtCm.community_id,
        members: [`m${this.userCmid}`, `m${this.tgtCm.id}`],
      }
      this.chatLoading = true
      var self = this
      createPersonalTalk(setupFormData(d))
        .then(function (response) {
          self.mergeAndMoveToTalk(response.data)
          self.chatLoading = false
          self.open = false
        })
        .catch(function (error) {
          console.error(error)
          self.chatLoading = false
          self.shortMsg($T('common.failed.register'), true)
        })
    },
    onAlbumClicked() {
      this.$store.commit('OPEN_UPLOAD', {
        cid: this.tgtCm.community_id,
        members: [`m${this.tgtCm.id}`],
      })
    },
    onEventRegistered(d) {
      var toCid = this.getRouteCid()
      if (toCid && this.tgtCm.community_id != toCid) toCid = this.tgtCm.community_id
      this.$router.push({
        name: 'calendarYm',
        params: { id: toCid, t: this.$moment(d).format('YYYYMM') },
      })
    },
    getCurrent() {
      return this.$moment()
    },
    onClickCamera() {
      this.selectCoverDialog = true
    },
    getMessage(fieldName) {
      return this.errors.collect(fieldName)
    },
    saveSelf() {
      if (this.tgtCm.nickname == this.profileName && !this.$refs.cover.isChanged)
        return this.closeDialog()

      this.loading = 'SELF'

      var self = this
      this.$validator.validateAll().then((result) => {
        if (!result) return (self.loading = null)

        var cid = this.tgtCm.community_id
        var cmid = this.tgtCm.id
        var n = this.profileName
        var t = time()

        var data = new FormData()
        data.append('cmid', cmid)
        data.append('profileName', n)
        data.append('selectedPath', this.$refs.cover.path)
        self.$refs.cover.appendNewCoversToForm(data, 'files')
        self.$refs.cover.appendDeletedCoversToForm(data, 'deletedPathes')
        self.loadingAccept = true
        saveNameAndCover(data)
          .then(function (response) {
            // update local cache
            console.warn(response)

            var key = `groups-members-${cid}`
            $commin.clientdb.getObject(key, function (data) {
              if (data && data.cms && data.cms[cmid]) {
                var cm = data.cms[cmid]
                cm.cover_changed_at = t
                cm.nickname = n
                $commin.clientdb.putObject(key, data)
              }
              self.$emit('profileChanged', { cmid: cmid, t: t, name: n })
              self.$store.commit('COM_UPDATE_PROFILE', { cid: cid, path: response.cover_path })
              self.loading = null
              self.closeDialog()
            })
          })
          .catch(function (e) {
            self.loading = null
            console.error(e)
            self.errEditData()
          })
      })
    },
  },
}
</script>

<style scoped>
.container {
  padding: 0px 24px 12px 24px;
}
.le-tbx .container {
  padding: 0px 24px 0 24px;
}
.c-member {
  position: relative;
  margin-top: 5px;
}
.le-tbs .c-img {
  position: absolute;
  width: 100%;
  top: -12px;
  left: 0;
  display: flex;
}
.c-img img {
  margin: 0 auto;
}
.c-explain {
  flex-grow: 1;
  padding-left: 24px;
  width: calc(100% - 164px);
}
.le-tbs .c-explain {
  padding: 170px 0 0 0;
  width: 100%;
}
.c-name {
  text-align: left;
  font-size: 28px;
  padding-bottom: 8px !important;
  color: rgba(0, 0, 0, 0.87);
}
.c-role {
  text-align: left;
  font-size: 16px;
  padding-bottom: 10px;
  color: rgba(0, 0, 0, 0.54) !important;
}
.c-role.f-danger {
  color: #e64a19 !important;
}
.c-self-mark {
  position: absolute;
  top: -3px;
  left: 117px;
  z-index: 2;
}
.le-tbs .c-self-mark {
  position: absolute;
  top: -14px;
  left: 0;
  width: 100%;
  z-index: 2;
}
.le-tbs .c-self-mark i {
  position: absolute;
  transform: translateX(34px);
  top: 0px;
  left: 50%;
}
.c-self-mark i {
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.6));
}
.c-com {
  margin-left: -5px;
}
.c-tag-edit {
  margin: 0 0 8px 0;
}
.c-tag-origin {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
  margin-top: 4px;
}
.c-tag-row {
  display: flex;
  align-items: center;
}
.c-tag-input {
  display: flex;
  align-items: center;
  max-width: 360px;
}
.c-tag-field {
  margin-top: 0;
  padding-top: 0;
}
/* 一覧(MemberList)のタグ表現に統一 */
.c-tag-mini {
  display: inline-block;
  vertical-align: middle;
  padding: 0 6px;
  border-radius: 9px;
  background-color: #e8f5e9;
  color: #1b5e20;
  font-size: 11px;
  line-height: 16px;
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.c-tag-mini i {
  color: #1b5e20 !important;
  margin-right: 2px;
  vertical-align: middle;
}
.c-tag-mini.c-hand {
  cursor: pointer;
}
.c-tag-add-chip {
  color: rgba(0, 0, 0, 0.55) !important;
}
.c-tag-add-chip .v-icon {
  color: rgba(0, 0, 0, 0.45) !important;
}
.c-tag-chip.c-hand,
.c-tag-add-chip.c-hand {
  cursor: pointer;
}
.c-tag-err {
  color: #e64a19;
  font-size: 12px;
  margin-top: 2px;
}
.c-icons {
  display: flex;
  margin: -8px 0 -8px 0;
}
.le-tbs .c-icons {
  justify-content: center;
}
.c-select-cover {
  width: 196px;
  margin: 15px auto 0 auto;
}
</style>
